import React from 'react';
import { Grid } from '@mui/material';
import { Select } from '../../Common';

const PostShutDownStatus = ({
    formState,
    setGlobalState,
    postShutDownStatuses,
}) => (
    <Grid container spacing={4}>
        <Grid item xs={6} md={6} lg={6}>
            <Select
                options={postShutDownStatuses}
                label="Post Shutdown Status"
                value={formState.finalCoolingApplianceStatusId}
                onChange={e => setGlobalState("finalCoolingApplianceStatusId", e.target.value)}
            />
        </Grid>
    </Grid>
);

export default PostShutDownStatus;
